import { Link, useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { PRODUCTS, COMPANY } from '../data/content.js'

export default function ProductDetail() {
  const { slug } = useParams()
  const { t } = useTranslation()
  const product = PRODUCTS.find((p) => p.slug === slug)

  if (!product) {
    return <div className="container section" style={{ color: 'var(--muted)' }}>{t('product.notFound')}</div>
  }

  const info = t(`productItems.${product.id}`, { returnObjects: true })
  const compositionLabels = t('productComposition', { returnObjects: true })
  const benefits = t(`productBenefits.${product.id}`, { returnObjects: true })
  const instructions = product.instructions
    ? t('productInstructions', { returnObjects: true })
    : null

  return (
    <section className="section">
      <div className="container">
        <p className="eyebrow"><Link to="/assortiment">← {t('products.title')}</Link></p>
        <h1 className="section-title">{info.title}</h1>
        <p className="section-sub">{info.desc}</p>

        <h2 className="section-title" style={{ fontSize: 'clamp(1.2rem, 2.5vw, 1.6rem)', marginTop: 56 }}>{t('product.composition')}</h2>
        <div className="spec-list">
          {product.composition.map((item) => (
            <div key={item.key} className="spec-row">
              <span className="k">{compositionLabels[item.key]}</span>
              <span className="v">{item.value}</span>
            </div>
          ))}
        </div>

        <h2 className="section-title" style={{ fontSize: 'clamp(1.2rem, 2.5vw, 1.6rem)', marginTop: 56 }}>{t('product.benefits')}</h2>
        <ul className="check-list" style={{ marginTop: 24 }}>
          {benefits.map((benefit) => (
            <li key={benefit}>{benefit}</li>
          ))}
        </ul>

        {instructions && (
          <>
            <h2 className="section-title" style={{ fontSize: 'clamp(1.2rem, 2.5vw, 1.6rem)', marginTop: 56 }}>{t('productInstructions.usage')}</h2>
            <div className="grid-3" style={{ marginTop: 24 }}>
              {product.instructions.items.map((item, idx) => (
                <div key={idx} className="card">
                  <h3>{instructions.krs[item.audienceKey.split('.')[1]]}</h3>
                  <p>{item.dose}</p>
                  <p style={{ marginTop: 6, color: 'var(--faint)' }}>{instructions.krs[item.noteKey.split('.')[1]]}</p>
                </div>
              ))}
            </div>
          </>
        )}

        <div className="hero-cta" style={{ justifyContent: 'flex-start', marginTop: 56 }}>
          <Link to="/contact" className="btn btn-primary">{t('hero.cta')}</Link>
          <a href={`https://wa.me/${COMPANY.whatsapp.replace(/\D/g, '')}`} target="_blank" rel="noopener noreferrer" className="btn btn-ghost">
            WhatsApp: {COMPANY.whatsapp}
          </a>
        </div>
      </div>
    </section>
  )
}